module.exports = __webpack_public_path__ + "assets/img/f6d2bd15c7cc227568054021113503f1.svg";